export default __webpack_public_path__ + "static/media/late_payment.7729234d.svg";